import { ActionType, createAction } from 'typesafe-actions';
import { FetchGroupsFulfilledPayload } from './types';

export const fetchGroupsFulfilled = createAction(
  'FETCH_GROUPS_FULFILLED',
  (payload: FetchGroupsFulfilledPayload) => payload
)<FetchGroupsFulfilledPayload>();

export type GroupsActions = ActionType<typeof fetchGroupsFulfilled>;
